import { computed } from "vue";
import { isKnownIcon } from "@/util/staticIcons";
import type { IdNameCode } from "../types";

export type HotelDirectoryListItemProps = {
  hotel: {
    attributeIds: number[];
  };
  hotelAttributes: IdNameCode[];
};

export function useHotelDirectoryListItem(props: Readonly<HotelDirectoryListItemProps>) {
  const localHotelAttributes = computed(() =>
    (props.hotel.attributeIds ?? []).map((id) => {
      const attr = props.hotelAttributes.find((item) => item.id === id)!;
      const icon = `hotel-attribute_${(attr.code ?? "").toLocaleLowerCase()}`;

      return {
        icon: isKnownIcon(icon) ? icon : null,
        name: attr.name,
      };
    }).filter((item) => !!item.name),
  );

  return {
    localHotelAttributes,
  };
}
